/* @flow */

export default class SetPasswordRequest {
  email: string;
  token: string;
  password: string;
}
